import * as React from 'react';

export interface ICloseButton {
    closeButtonAriaLabel?: string;
    label?: string;
    onClose(): void;

}

export const CloseButton: React.FC<ICloseButton> = ({ closeButtonAriaLabel, label, onClose }) => {
    return (
    <button className='ms-invoicedelivery-banner__close-button' aria-label={closeButtonAriaLabel} onClick={onClose} >
        <span className='ms-invoicedelivery-banner__close-button__label' aria-hidden={true}>{label}</span>
    </button>
    );
};